export default __webpack_public_path__ + "static/media/pic_2.d29799cf.JPG";